import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=bc7459c4"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&id=bc7459c4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports